export default __webpack_public_path__ + "static/16_32-3e04527a82fcf6dbcd2e2c8ddbaf910a.png";